// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-form-item.blank .el-form-item__content {\n  width: 12em;\n}\n.el-form-item.blank .el-form-item__content .el-input .el-input__inner {\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
